export function navigation(){return document.querySelector('[data-nav]')}
